/*******************************************************************************
Weather Actions
Hawaiian Macadamia Nut Services
Alexander Self
Weather data derived from: https://developer.climacell.co/; saved in AWS db
06.18.20
*******************************************************************************/
import { FETCH_WEATHER, SET_WEATHER_TIME,
  SET_LOCAL_WEATHER_SITE, SET_WEATHER_LOCATION, DOWNLOAD_DATA } from './types';
import axios from 'axios';
import { TIME } from './constants';
import { ROOT_URL } from '../constants';
const $ = window.$;
const Materialize = window.Materialize;
/**
* fetchWeather(): Fetches weather and air quality records by location
* @param {String} date: date to fetch
* @returns {Object} locations: array of locations with weather and aq data
* @called-in: ['weather.js']
**/
export function fetchWeather(date) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/weather`, {
      headers: { authorization: localStorage.getItem('token') },
      params: { date }
    }).then((res) => {
        let { locations } = res.data;
        dispatch({ type: FETCH_WEATHER, payload: locations, date })
      }).catch((err) => { console.error(err) });
  }
}
/**
* downloadWeather(): Fetches weather and air quality records and emails them out
* @param {String} date1: Start date
* @param {String} date2: End date
* @param {String} email: email to send file to
* @returns
* @called-in: ['weather.js']
**/
export function downloadWeather(date1, date2, email) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/downloadWeather`, {
      headers: { authorization: localStorage.getItem('token') },
      params: { date1, date2, email }
    }).then((res) => {
        $('#preloader').css('display','none');
        success('Success fetching weather data');
        dispatch({ type: DOWNLOAD_DATA })
      }).catch((err) => {
        $('#preloader').css('display','none');
        error('There was an error fetching weather data');
      });
  }
}
/**
* setWeatherTime(): Sets the time of the data set and fetches the data object for display
* @param {String} val: The value from the time slider(1-18); used to map to actual Time
* @param {Array} locations: All weather locations with data sets
* @param {Number} loc: The id of the location(site)
* @returns {Object}
* @called-in: ['weather.js']
**/
export function setWeatherTime(val, locations, loc) {
  let _loc = locations.find((l) => Number(l.id) === Number(loc));
  if (_loc === undefined) return { type: SET_WEATHER_TIME, payload: TIME[val] };

  let airQuality = _loc.airQuality.find((a) => {
    let re = new RegExp(TIME[val],"g");
    let time = a.observation_time.split(' ')[1];
    let hour = time.split(':')[0];
    return hour.match(re);
  });
  let weather = _loc.weather.find((a) => {
    let re = new RegExp(TIME[val],"g");
    let time = a.observation_time.split(' ')[1];
    let hour = time.split(':')[0];
    return hour.match(re);
  });

  return {
    type: SET_WEATHER_TIME,
    payload: TIME[val],
    loc: {
      ..._loc,
      airQuality,
      weather
    },
    dataset: {
      airQuality: _loc.airQuality,
      weather: _loc.weather
    }
  }
}
/**
* setLocalWeatherSite(): Sets the site of the data set and fetches the data object for display
* @param {String} val: The value from the location slider(dynamic ids of the locations)
* @param {Array} locations: All weather locations with data sets
* @param {Number} _time: The current time value saved in state
* @returns {Object}
* @called-in: ['weather.js']
**/
export function setLocalWeatherSite(val, locations, _time) {
  let _loc = locations.find((l) => Number(l.id) === Number(val));
  if (_loc === undefined) return { type: SET_LOCAL_WEATHER_SITE, payload: _loc };

  let airQuality = _loc.airQuality.find((a) => {
    let re = new RegExp(_time,"g");
    let time = a.observation_time.split(' ')[1];
    let hour = time.split(':')[0];
    return hour.match(re);
  });
  let weather = _loc.weather.find((a) => {
    let re = new RegExp(_time,"g");
    let time = a.observation_time.split(' ')[1];
    let hour = time.split(':')[0];
    return hour.match(re);
  });

  return {
    type: SET_LOCAL_WEATHER_SITE,
    payload: {
      ..._loc,
      airQuality,
      weather
    },
    dataset: {
      airQuality: _loc.airQuality,
      weather: _loc.weather
    }
  }
}

/**
* setWeatherLocation): Sets the location of the data: 71, 72, 75
* @param {Number} loc: The value of the location
* @returns {Object}
* @called-in: ['weather.js']
**/
export function setWeatherLocation(loc) {
  return {
    type: SET_WEATHER_LOCATION,
    payload: loc
  }
}

function error(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: 'ERROR',
    err
  };
}
function success(msg) {
  Materialize.toast(msg, 4000, 'rounded green');
  return {
    type: 'SUCCESS'
  };
}

/* END */



// WEBPACK FOOTER //
// ./src/weather/actions.js